const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

export interface HireRatingRoundSummary {
  id: string;
  cohortPeriod: string;
  closeDate: string | null;
  createdAt: string;
  eventCount: number;
}

export interface HireRatingRoundDetail {
  id: string;
  cohortPeriod: string;
  closeDate: string | null;
  invitationMessage: string;
  landingPageMessage: string;
  createdAt: string;
  events: {
    id: string;
    hireeName: string;
    hireeRole: string;
    department: string;
    hireDate: string;
  }[];
}

async function authFetch(url: string, accessToken: string, init?: RequestInit) {
  const res = await fetch(`${BASE}${url}`, {
    ...init,
    headers: {
      ...(init?.headers ?? {}),
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res;
}

export async function fetchRounds(accessToken: string): Promise<HireRatingRoundSummary[]> {
  const res = await authFetch('/api/hire-rating-rounds', accessToken);
  return res.json();
}

export async function fetchRound(id: string, accessToken: string): Promise<HireRatingRoundDetail> {
  const res = await authFetch(`/api/hire-rating-rounds/${id}`, accessToken);
  return res.json();
}

export async function createRound(
  accessToken: string,
  cohortPeriod: string,
  closeDate?: string
): Promise<{ id: string }> {
  const res = await authFetch('/api/hire-rating-rounds', accessToken, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ cohortPeriod, closeDate: closeDate ?? null }),
  });
  return res.json();
}

export async function updateRoundMessages(
  accessToken: string,
  id: string,
  invitationMessage: string,
  landingPageMessage: string,
  closeDate?: string
): Promise<void> {
  await authFetch(`/api/hire-rating-rounds/${id}/messages`, accessToken, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ invitationMessage, landingPageMessage, closeDate: closeDate ?? null }),
  });
}

export async function deleteRound(accessToken: string, id: string): Promise<void> {
  await authFetch(`/api/hire-rating-rounds/${id}`, accessToken, { method: 'DELETE' });
}

export async function assignEventsToRound(
  accessToken: string,
  roundId: string,
  eventIds: string[]
): Promise<void> {
  await authFetch(`/api/hire-rating-rounds/${roundId}/events`, accessToken, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ eventIds }),
  });
}
